const materials = [
  {
    id: "M_Tyre_Trelleborg_TM800",
    color: 0x1a1a1a,
    roughness: 0.9,
    metalness: 0,
    map: "T_TM800_ORM",
    roughnessMap: "T_TM800_ORM",
    normalMap: "T_TM800_N",
    aoMap: "T_TM800_ORM",
    //normalScale: [-1.3, -1.3],
    type: "MeshStandardMaterial",
    //envMapIntensity: 0.15,
  },
];

export default materials;
